import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SalesPage from "@/pages/SalesPage";
import AdminLeads from "@/pages/AdminLeads";

const useTrackingPixels = () => {
  useEffect(() => {
    const metaId = process.env.REACT_APP_META_PIXEL_ID;
    if (metaId) {
      const n = (window.fbq =
        window.fbq ||
        function () {
          n.queue.push(arguments);
        });
      n.queue = n.queue || [];
      n.loaded = true;
      n.version = "2.0";
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
      window.fbq("init", metaId);
      window.fbq("track", "PageView");
    }
    const tiktokId = process.env.REACT_APP_TIKTOK_PIXEL_ID;
    if (tiktokId) {
      window.TiktokAnalyticsObject = "ttq";
      const ttq = (window.ttq = window.ttq || []);
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
      ttq.setAndDefer = (t, e) => {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      ttq.methods.forEach((m) => ttq.setAndDefer(ttq, m));
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${tiktokId}&lib=ttq`;
      document.head.appendChild(s);
      ttq.page();
    }
  }, []);
};

function App() {
  useTrackingPixels();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SalesPage />} />
          <Route path="/admin" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#14141a",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#f4f1ea",
          },
        }}
      />
    </div>
  );
}

export default App;
